// appbarStyles.js
const appbarStyles = (theme) => ({
    header: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[1],
    },
});

export default appbarStyles;
